define([
	"dojo/_base/declare",
	"dijit/MenuItem",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"csi/page/SearchManager",
	"csi/reflection",
	"csi/service/imageService",
	"csi/session",
	"csi/state/rootStore",
	"csi/utility/routerUtility",
	"csi/view/ToolbarDropDown",
	"csi/widget/DropDownMenu",
	"dojo/text!csi/templates/card.html"
], function(declare, MenuItem, _, html, locale, SearchManager, reflection, {waitForImagesToLoad}, session, {sessionStore}, {getLocationForUrl}, ToolbarDropDown, DropDownMenu, template) {

	return declare(ToolbarDropDown, {
		iconClass: "",
		showLabel: false,

		_createDropDown: function() {
			var urlCurrent = session.getLocationValue(session.LOCATION_URL);
			var ctx = this.actionToolbar.view.getContext();
			var bContent;

			ctx.bPopup = true;
			ctx.bReserveClick = true;
			ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
			ctx.setReadOnly(true);

			var firstLabel = new MenuItem({
				"class": "csi-nav-dropdown-first-item"
			});

			html.create("span", {
				"class": "csi-nav-dropdown-label",
				innerText: locale.resource("LastVisitedList")
			}, firstLabel.textDirNode);

			this.dropDown = new DropDownMenu({
				"class": "csi-nav-dropdown csi-nav-dropdown-list",
				refNode: this.domNode
			});
			this.dropDown.addChild(firstLabel);

			ctx.forEach(sessionStore.lastVisited, function(ctx) {
				var node = ctx.getNode();
				if (node && (node.$URL != urlCurrent)) {
					const href = getLocationForUrl(node.$URL);

					var item = new MenuItem({
						label: template,
						onClick: function(e) {
							if (e.button === 0) {
								html.openWindowOnMouseClick(e, href);
							}
						}
					});

					var defs = SearchManager.getCardItemDefs(node.$Type, null, null, true);
					var rowNode = html.templateToHtml(ctx, item.containerNode, defs);

					if (node.$URL) {
						html.createRowAnchor(rowNode, href);
					}

					this.dropDown.addChild(item);
					bContent = true;
				}
			}, this);

			if (!bContent) {
				this.dropDown.addChild(new MenuItem({
					"class": "csi-nav-dropdown-empty-item",
					label: locale.resource("LastVisitedEmpty")
				}));
			}
		},

		postCreate: function() {
			this.inherited(arguments);
			this.addTooltip(this, this.defAction.m_id);
		},

		/**
		 * @override
		 * Create drop down if it does not yet exist. If it already exists, it will be opened in another method, so nothing else to do here
		 */
		async onClick() {
			if (!this.dropDown) {
				this._createDropDown();
				await waitForImagesToLoad();
				this.openDropDown();
			}
		},

		loadDropDown: function(/*Function*/callback) {
			if (this.dropDown) {
				this.inherited(arguments);
			}
		}
	});
});